import { buttonClassName } from '@emailforge/ui';
import { Link, NavLink } from 'react-router-dom';

import { Logo } from '@/components/ui/Logo';

const linkStyle = { fontSize: 13, color: 'var(--ink-2)', textDecoration: 'none', padding: '6px 10px', borderRadius: 'var(--r-2)' } as const;

export function MarketingNav() {
  return (
    <nav
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 40,
        background: 'oklch(0.988 0.003 85 / 0.9)',
        backdropFilter: 'blur(8px)',
        borderBottom: '1px solid var(--line)',
      }}
    >
      <div
        style={{
          maxWidth: 1280,
          margin: '0 auto',
          padding: '14px 24px',
          display: 'flex',
          alignItems: 'center',
          gap: 20,
        }}
      >
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none', color: 'var(--ink)' }}>
          <Logo size={22} />
          <span style={{ fontWeight: 600, fontSize: 15, letterSpacing: -0.01 }}>Emailforge</span>
          <span
            className="mono"
            style={{ fontSize: 9.5, color: 'var(--ink-3)', letterSpacing: 0.04, textTransform: 'uppercase' }}
          >
            a contra product
          </span>
        </Link>

        <div style={{ flex: 1 }} />

        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <NavLink to="/" end style={linkStyle}>Product</NavLink>
          <NavLink to="/pricing" style={linkStyle}>Pricing</NavLink>
          <NavLink to="/export-pack" style={linkStyle}>Export Pack</NavLink>
          <NavLink to="/docs" style={linkStyle}>Docs</NavLink>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Link to="/login" className={buttonClassName({ variant: 'ghost', size: 'sm' })}>Sign in</Link>
          <Link to="/signup" className={buttonClassName({ variant: 'flame', size: 'sm' })}>
            Start free — 14 days
          </Link>
        </div>
      </div>
    </nav>
  );
}
